import { CardProps, Card as MuiCard } from "@mui/material";

type Props = CardProps;

export const Card = ({ children, ...props }: Props) => {
  return <MuiCard {...props}>{children}</MuiCard>;
};
